import { render } from "./TailoringOrderPage.vue?vue&type=template&id=2065e882&scoped=true"
import script from "./TailoringOrderPage.vue?vue&type=script&lang=js"
export * from "./TailoringOrderPage.vue?vue&type=script&lang=js"

import "./TailoringOrderPage.vue?vue&type=style&index=0&id=2065e882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2065e882"]])

export default __exports__